import api from "../services/api"
import {addProperyIfNotExists} from "../services/utils"

const state = {
  weeklyTracking: {},
  newWeeklyTracking: {
    id: 0,
    title: '',
    subtitle: '',
    order: 0,
    active: true,
  },
  weeklyTrackings: [],
  errors: []

}

const mutations = {
  WEEKLY_TRACKINGS_WEEKLY_TRACKINGS ( state, weeklyTrackings ) { state.weeklyTrackings = weeklyTrackings },
  WEEKLY_TRACKING_WEEKLY_TRACKING ( state, weeklyTracking ) { state.weeklyTracking = addProperyIfNotExists(weeklyTracking, state.newWeeklyTracking) },
  WEEKLY_TRACKING_WEEKLY_TRACKING_PROP ( state, payload ) { state.weeklyTracking[payload.property] = payload.value },
  WEEKLY_TRACKING_EMPTY_ERRORS ( state ) { state.errors = [] },
  WEEKLY_TRACKING_ADD_ERROR ( state, error ) { state.errors.push(error)}
}

const actions = {
  async getWeeklyTrackingsHTTP ( { commit }) {
    const weeklyTrackings = await api.get('/configuration/weeklyTracking')
    commit('WEEKLY_TRACKINGS_WEEKLY_TRACKINGS', weeklyTrackings.data.data)
  },
  async saveWeeklyTracking ( { state, commit, dispatch } ) {
    commit('WEEKLY_TRACKING_EMPTY_ERRORS')
    if( state.weeklyTracking.title == '') commit('WEEKLY_TRACKING_ADD_ERROR', 'El título es requerido')

    if( state.errors.length == 0 ) {
      if( state.weeklyTracking.id == 0 ) {
        return await dispatch('createWeeklyTrackingHTTP')
      } else {
        return await dispatch('updateWeeklyTrackingHTTP')
      }
    }
  },
  async createWeeklyTrackingHTTP ( { state, rootState } ) {
    let weeklyTracking = state.weeklyTracking
    weeklyTracking.createdBy = rootState.user.userId
    await api.post('/configuration/weeklyTracking', weeklyTracking )
    return 'Seguimiento semanal creado'
  },
  async updateWeeklyTrackingHTTP ( { state, rootState } ) {
    let weeklyTracking = state.weeklyTracking
    weeklyTracking.createdBy = rootState.user.userId
    weeklyTracking.updatedBy = rootState.user.userId
    await api.put('/configuration/weeklyTracking', weeklyTracking )
    return 'Seguimiento semanal actualizado'
  }
}

const getters = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}